import {MAX_COHORT, selectedJobs, validId} from './cohortContract.js'
export const SELECTION_PAGE_SIZE = 25
export function selectionCatalog(jobs) {
  if (!Array.isArray(jobs)) return {rows: [], signature: 'invalid', unavailable: true}
  const counts = new Map()
  for (const job of jobs) if (validId(job?.id)) counts.set(job.id, (counts.get(job.id) || 0) + 1)
  const rows = jobs.map((job, index) => {
    let binding = null
    try { binding = selectedJobs([job])[0] } catch { /* Incomplete saved rows remain unselectable. */ }
    const duplicate = counts.get(job?.id) > 1
    const readOnly = job?.readAccess?.readOnly === true || job?.readOnly === true
    const label = typeof job?.title === 'string' && job.title.trim() ? job.title : validId(job?.id) ? job.id : 'Saved row with unavailable identity'
    return {key: String(index), job, jobId: validId(job?.id) ? job.id : null, label, binding, selectable: !!binding && !duplicate && !readOnly, reason: readOnly ? 'This saved row is read-only; it cannot be selected for new work.' : duplicate ? 'Duplicate job identity; reconcile this saved list before selecting it.' : !binding ? 'Current account, championship, revision or fingerprint metadata is missing.' : ''}
  })
  // A reorder, title, removal, revision, fingerprint or ownership-binding change
  // invalidates picks. The browser never updates an approved list silently.
  const signature = JSON.stringify(rows.map(row => [row.jobId, row.label, row.binding, row.selectable, row.job?.ownerId, row.job?.version, row.job?.updatedAt]))
  return {rows, signature, unavailable: false}
}
export function selectionScope({actorId, session, filterScope, catalog}) {
  if (!validId(actorId) || typeof filterScope !== 'string' || !filterScope || catalog.unavailable) return null
  return JSON.stringify([actorId, session, filterScope, catalog.signature])
}
export const emptySelection = scope => ({scope, picked: [], page: 1, reviewing: false, message: ''})
export function toggleSelection(state, catalog, jobId, checked) {
  if (state.reviewing || !catalog.rows.some(row => row.jobId === jobId && row.selectable)) return state
  const picked = state.picked.filter(id => id !== jobId)
  if (checked) {
    if (picked.length >= MAX_COHORT) return {...state, message: 'At most 1,000 exact saved jobs can be selected. Remove a selection before adding another.'}
    picked.push(jobId)
  }
  return {...state, picked, message: ''}
}
export function currentSelection(state, catalog) {
  if (!state.picked.length || state.picked.length > MAX_COHORT || new Set(state.picked).size !== state.picked.length) return null
  const jobs = state.picked.map(id => catalog.rows.find(row => row.jobId === id && row.selectable)?.job)
  try { selectedJobs(jobs); return jobs } catch { return null }
}
export function selectionPage(state, catalog) {
  const pages = Math.max(1, Math.ceil(catalog.rows.length / SELECTION_PAGE_SIZE))
  const page = Math.max(1, Math.min(pages, state.page))
  return {page, pages, rows: catalog.rows.slice((page - 1) * SELECTION_PAGE_SIZE, page * SELECTION_PAGE_SIZE)}
}
